export default "__VITE_ASSET__Bcl$uXDH__"